import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../redux/actions/actions";
import { BaseUrlReports } from "../../container/BaseUrl/BaseUrl";
import axios from "axios";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import { TiWarningOutline } from "react-icons/ti";
import { Spinner } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};
const Servicereport = (props) => {
  const selectAgentRef = useRef(null);
  const selectSkillsetRef = useRef(null);
  const selectDispositionRef = useRef(null);

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const animatedComponents = makeAnimated();
  const [apiCallsMade, setApiCallsMade] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [calldetailsreportlist, setCalldetailsreportlist] = useState({});
  const [agentlistdata, setAgentlistdata] = useState([]);
  const [skillsetdata, setSkillsetdata] = useState([]);
  const [disposition, setDisposition] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [servicespinner, setservicespinner] = useState(false);

  const [selectedagent, setSelectedagent] = useState([]);
  const [selectedskillset, setSelectedskillset] = useState([]);
  const [selecteddisposition, setSelecteddisposition] = useState([]);

  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  const optionsAgent = agentlistdata.map((agent) => ({
    value: agent.agent_id,
    label: agent.agent_name,
  }));

  // const optionsAgent = agentlistdata.map((item)=>{
  //     console.log('itemmmmmmmmmmmm',item.agent_name)
  // })

  const optionsSkillset = skillsetdata.map((skillset) => ({
    value: skillset,
    label: skillset,
  }));

  const optionsDisposition = disposition.map((dispos) => ({
    value: dispos,
    label: dispos,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  useEffect(() => {
    if (!apiCallsMade) {
      serviceDetailsReportData();
      agentCallDetailsReportDataSkillsetList();
      setApiCallsMade(true);
    }
  }, [apiCallsMade]);

  useEffect(() => {
    serviceDetailsReportData();
  }, [page]);

  const serviceDetailsReportData = async () => {
    setApiCallsMade(true);
    setservicespinner(true);
    await axios
      .post(
        BaseUrlReports + "api/service_report",
        {
          start_date: fromdate ? fromdate : defaultValue,
          end_date: todate ? todate : defaultValue,
          skillsets: selectedskillset,
          tenent_id: localStorage.getItem("TenantId"),
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data) {
          setservicespinner(false);
          console.log("setCalldetailsreportlistsetCalldetailsreportlist", res);
          setCalldetailsreportlist(res.data.data);
          setPagination(res.data.count);
        }
      })

      .catch((error) => {
        setservicespinner(false);
        console.log(error);
      });
  };

  const handleChange = (event, value) => {
    console.log(value);
    setPage(value);
  };

  const agentCallDetailsReportDataSkillsetList = async () => {
    setApiCallsMade(true);
    await axios
      .post(
        BaseUrlReports + "api/skillsetmasters",
        {
          tenent_id: localStorage.getItem("TenantId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data) {
          setSkillsetdata(res.data.skillsets);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };

  const handleSelectAgentChange = (selectedOptions) => {
    const value = selectedOptions.map((option) => option.value);
    setSelectedagent(value);
  };

  const handleSelectSkillsetChange = (selectedOptions) => {
    const label = selectedOptions.map((option) => option.label);
    setSelectedskillset(label);
  };

  const handleSelectDispositionChange = (selectedOptions) => {
    const label = selectedOptions.map((option) => option.label);
    setSelecteddisposition(label);
  };

  const resetButton = () => {
    selectAgentRef.current.clearValue();
    selectSkillsetRef.current.clearValue();
    selectDispositionRef.current.clearValue();
    setTodate("");
    setFromdate("");
    handelCloseFilter();
  };

  return (
    <>


      <div
        class={
          showfilter
            ? "offcanvas offcanvas-end show"
            : "offcanvas offcanvas-end"
        }
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasRightLabel">
            Filter
          </h5>
          <button
            onClick={handelCloseFilter}
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <div class="mb-3">
            <label for="exampleInputfromdate" class="form-label">
              From Date <small class="text-danger">*</small>
            </label>
            <input
              type="date"
              value={fromdate}
              onChange={(e) => {
                setFromdate(e.target.value);
              }}
              class="form-control form-control-lg"
              id="exampleInputfromdate"
            />
          </div>
          <div class="mb-3">
            <label for="exampleInputtodate" class="form-label">
              To Date <small class="text-danger">*</small>
            </label>
            <input
              value={todate}
              type="date"
              onChange={(e) => {
                setTodate(e.target.value);
              }}
              class="form-control form-control-lg"
              id="exampleInputtodate"
            />
          </div>

          <div class="mb-3">
            <label for="exampleInputtodate" class="form-label">
              Skillset <small class="text-danger">*</small>
            </label>
            <Select
              ref={selectSkillsetRef}
              closeMenuOnSelect={true}
              components={animatedComponents}
              isMulti
              options={optionsSkillset}
              placeholder="Select Skillset"
              styles={customStyles}
              onChange={handleSelectSkillsetChange}
            />
          </div>
        </div>
        <div class="offcanvas-sub-btn d-flex justify-content-between mb-1">
          <button
            onClick={handelCloseFilter}
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            class="btn btn-secondary mx-1 btn-sm flex-fill"
          >
            Close
          </button>
          <button
            onClick={resetButton}
            type="button"
            class="mx-1 btn btn-warning btn-sm flex-fill"
          >
            Reset
          </button>
          <button
            onClick={() => {
              setPage(1);
              serviceDetailsReportData();
              handelCloseFilter();
            }}
            type="button"
            class="mx-1 btn-sm btn btn-primary flex-fill"
          >
            Submit
          </button>
        </div>
      </div>

      <div class="sub-wapper bg-light" id="mainid">
        <div class="container-fluid">
          <div class="pt-3">
            <div
              class="sub-main card border-0 rounded-0"
              id="menu1"
              style={{ height: "98vh" }}
            >
              <div class="card-header rounded-0 shadow-sm border-0 bg-white d-flex justify-content-between align-content-center">
                <span className="fw-bold">Service Reports</span>
                <div>
                  <button
                    type="button"
                    class="btn btn-outline-primary rounded-0 fs-13 me-2"
                  >
                    <i class="fa-solid fa-cloud-arrow-down mx-1"></i>Download
                    Report
                  </button>
                  <button
                    onClick={handelShowFilter}
                    type="button"
                    class="btn btn-primary rounded-0 fs-13"
                  >
                    <i class="fa-solid fa-filter mx-1"></i>
                    Filter
                  </button>
                    <button
                      type="button"
                      class="btn btn-outline-primary mx-2 rounded-0 fs-13 me-2"
                      onClick={() => {
                        props.setSelectedMenu("ReportMenu");
                      }}
                    >
                      <i class="fa-solid fa-arrow-left mx-1"></i>
                      Back
                    </button>
                </div>
              </div>
              <div
                class="card-body px-1 "
                style={{
                  minWidth: "100%",
                  overflowX: "auto",
                  overflowY: "clip",
                }}
              >
                <div>
                  <div
                    class="table-responsive h-75vh"
                    style={{ width: "150vw" }}
                  >
                    <table
                      class="table  table-hover"
                      style={{ fontSize: "14px" }}
                    >
                      <thead>
                        <tr>
                          <th scope="col">Skillset</th>
                          <th scope="col">Abandoned Count</th>
                          <th scope="col">Answered Within20s</th>
                          <th scope="col">Average Handling Time</th>
                          <th scope="col">Average Talk Time</th>
                          <th scope="col">Interaction Count</th>
                          <th scope="col">Service Level Percentage</th>
                          <th scope="col">Total Call</th>
                          <th scope="col">Total Talk Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {calldetailsreportlist &&
                        Object.entries(calldetailsreportlist).length > 0 ? (
                          Object.entries(calldetailsreportlist).map(
                            ([category, categoryData]) => {
                              const averageTalkTimeInSeconds =
                                categoryData.averageTalkTime;
                              const averageTalkTimeInMilliseconds =
                                averageTalkTimeInSeconds * 1000;
                              const averageTalkTimeDuration = moment.duration(
                                averageTalkTimeInMilliseconds
                              );
                              const formattedAverageTalkTime = moment
                                .utc(averageTalkTimeDuration.as("milliseconds"))
                                .format("HH:mm:ss");

                              const averagehandelingInSeconds =
                                categoryData.averageHandlingTime;
                              const averageHandelingTimeInMilliseconds =
                                averagehandelingInSeconds * 1000;
                              const averagehandelingTimeDuration =
                                moment.duration(
                                  averageHandelingTimeInMilliseconds
                                );
                              const formattedAverageHandelingTime = moment
                                .utc(
                                  averagehandelingTimeDuration.as(
                                    "milliseconds"
                                  )
                                )
                                .format("HH:mm:ss");

                              const totalTalkTimeInSeconds =
                                categoryData.totalTalkTime;
                              const totalTalkTimeInMilliseconds =
                                totalTalkTimeInSeconds * 1000;
                              const totalTalkTimeDuration = moment.duration(
                                totalTalkTimeInMilliseconds
                              );
                              const totalTalkTime = moment
                                .utc(totalTalkTimeDuration.as("milliseconds"))
                                .format("HH:mm:ss");

                              const now = Math.ceil(
                                categoryData.serviceLevelPercentage
                              );

                              return (
                                <tr key={category}>
                                  <th scope="row">{category}</th>
                                  <td>{categoryData.abandonedCount}</td>
                                  <td>{categoryData.answeredWithin20s}</td>
                                  <td>{formattedAverageHandelingTime}</td>
                                  <td>{formattedAverageTalkTime}</td>
                                  <td>{categoryData.interactionCount}</td>
                                  <td>
                                    <ProgressBar
                                      now={now}
                                      label={`${now}%`}
                                      className="w-50"
                                    />
                                  </td>
                                  {/* <td>{Math.ceil(categoryData.serviceLevelPercentage)+'%'}</td> */}
                                  <td>{categoryData.totalCall}</td>
                                  <td>{totalTalkTime}</td>
                                </tr>
                              );
                            }
                          )
                        ) : (
                          <div
                            className="d-flex justify-content-center align-items-center position-absolute"
                            style={{ minHeight: "400px", left: "50%" }}
                          >
                            <div
                              className="d-flex"
                              style={{ flexDirection: "column" }}
                            >
                              {servicespinner ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                  />
                                  <span
                                    className="position-relative mt-2"
                                    style={{ left: "-10px" }}
                                  >
                                    Loading...
                                  </span>
                                </>
                              ) : (
                                <>
                                  <TiWarningOutline
                                    size={30}
                                    className="mx-auto text-muted"
                                  />
                                  <span className="fw-bold text-muted">
                                    No Data Found
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card-footer rounded-0  bg-white d-flex justify-content-end align-content-center">
                <nav aria-label="Page navigation example">
                  <Stack spacing={2}>
                    <Pagination
                      onChange={handleChange}
                      count={Math.ceil(pagination / 10)}
                      page={page}
                      color="primary"
                      variant="outlined"
                      shape="rounded"
                      size="small"
                    />
                  </Stack>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(Servicereport);
